export enum EOfferType {
	general,
	special,
	benifit,
}